import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

const CardSelectedAmount = ({selectedAmount}) => {
    const styles = useMultiStyleConfig('GiftCertificate')
    return (
        <Box {...styles.rightBox.cardSelectedAmount}>
            <Text {...styles.rightBox.label}>
                <FormattedMessage id="eGiftcard.product.amount" defaultMessage="Amount" />
            </Text>
            <Text {...styles.rightBox.value}>${selectedAmount}</Text>
        </Box>
    )
}

CardSelectedAmount.propTypes = {
    selectedAmount: PropTypes.any
}

export default CardSelectedAmount
